import Flex from "app/components/UI/Flex";
import PropTypes from "prop-types";
import React from "react";
import classes from "./RaisedText.module.css";

export const RaisedText = ({ className, children, label }) => (
  <div className={classes.raisedText}>
    <Flex direction="row" middle className={classes.raisedText__content}>
      <Flex size={1} className={classes.raisedText__label}>
        {label}
      </Flex>
      <div>{children}</div>
    </Flex>
  </div>
);

RaisedText.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};

export default RaisedText;



// WEBPACK FOOTER //
// ./src/app/components/UI/RaisedText/RaisedText.js